const MAP = {
  twitch: {
    icon: "mdi-twitch"
  },
  youtube: {
    icon: "mdi-youtube"
  }
}

export default {
  methods: {
    getSocialiteIcon(driver) {
      let info = MAP[driver]
      return info ? info.icon : 'mdi-help'
    },
    getSocialiteName(driver) {
      let key = 'socialite.' + driver + '.name'
      let translation = this.$t(key)
      return translation != key ? translation : driver
    },
    getSocialiteColor(driver) {
      switch(driver) {
        case 'twitch':
          return '#a970ff'
        case 'youtube':
          return '#f00'
        default:
          break
      }
      return undefined
    }
  }
}
